var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h2", { staticClass: "mb-10" }, [
            _vm._v("Solicitud Gasto de Representación")
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Nombre Jefatura *" } },
                  [
                    !_vm.bossInfoLoaded || _vm.directBoss == null
                      ? _c("list-user", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required:
                                  !_vm.bossInfoLoaded || _vm.directBoss == null
                              },
                              expression:
                                "{\n              'required': !bossInfoLoaded || directBoss == null\n            }"
                            }
                          ],
                          ref: "functionary",
                          staticClass: "w-100",
                          attrs: {
                            disabled: _vm.loadingBossInfo,
                            autocomplete: "",
                            "data-cy": "direct-boss",
                            "data-vv-as": "nombre jefatura",
                            name: "directBoss",
                            label: "",
                            placeholder: _vm.directBossPlaceholder,
                            danger: _vm.errors.has(
                              "custom-document.directBoss"
                            ),
                            "danger-text": _vm.errors.first(
                              "custom-document.directBoss"
                            ),
                            "filters-user-group": "esOficina:N"
                          },
                          on: { "set-position": _vm.setDirectBoss },
                          model: {
                            value: _vm.directBoss,
                            callback: function($$v) {
                              _vm.directBoss = $$v
                            },
                            expression: "directBoss"
                          }
                        })
                      : _c("b-form-input", {
                          attrs: {
                            disabled: "",
                            "data-cy": "functionary",
                            name: "functionary",
                            type: "text",
                            placeholder: "Cargando...",
                            value: _vm.directBoss || "Cargando..."
                          },
                          model: {
                            value: _vm.formData.directBoss,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "directBoss", $$v)
                            },
                            expression: "formData.directBoss"
                          }
                        })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Cargo Jefatura *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has("custom-document.position")
                          ? false
                          : null,
                        "data-cy": "position",
                        "data-vv-as": "cargo",
                        name: "position",
                        type: "text",
                        disabled:
                          _vm.loadingBossInfo ||
                          !_vm.formData.directBoss ||
                          _vm.disablePositionInput,
                        placeholder: _vm.positionPlaceholder
                      },
                      model: {
                        value: _vm.formData.position,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "position", $$v)
                        },
                        expression: "formData.position"
                      }
                    }),
                    _vm.errors.has("custom-document.position")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.position"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Actividad *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has("custom-document.activity")
                          ? false
                          : null,
                        "data-cy": "activity",
                        "data-vv-as": "actividad",
                        name: "activity",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.activity,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "activity", $$v)
                        },
                        expression: "formData.activity"
                      }
                    }),
                    _vm.errors.has("custom-document.activity")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.activity"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Fecha Ejecución Actividad *" } },
                  [
                    _c("date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        "input-class": {
                          "mx-input": true,
                          "border-danger": _vm.errors.has(
                            "custom-document.activityExecDate"
                          )
                        },
                        "data-cy": "activity-execution-date",
                        name: "activityExecDate",
                        format: "DD-MM-YYYY",
                        "value-type": "YYYY-MM-DD",
                        "data-vv-as": "fecha ejecución actividad",
                        danger: _vm.errors.has(
                          "custom-document.activityExecDate"
                        ),
                        "danger-text": _vm.errors.first(
                          "custom-document.activityExecDate"
                        )
                      },
                      model: {
                        value: _vm.formData.activityExecDate,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "activityExecDate", $$v)
                        },
                        expression: "formData.activityExecDate"
                      }
                    }),
                    _vm.errors.has("custom-document.activityExecDate")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.activityExecDate"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Hora Ejecución Actividad *" } },
                  [
                    _c("date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        "input-class": {
                          "mx-input": true,
                          "border-danger": _vm.errors.has(
                            "custom-document.activityExecTime"
                          )
                        },
                        type: "time",
                        "data-cy": "activity-execution-time",
                        name: "activityExecTime",
                        format: "HH:mm",
                        "value-type": "HH:mm",
                        "data-vv-as": "hora ejecución actividad",
                        danger: _vm.errors.has(
                          "custom-document.activityExecTime"
                        ),
                        "danger-text": _vm.errors.first(
                          "custom-document.activityExecTime"
                        )
                      },
                      model: {
                        value: _vm.formData.activityExecTime,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "activityExecTime", $$v)
                        },
                        expression: "formData.activityExecTime"
                      }
                    }),
                    _vm.errors.has("custom-document.activityExecTime")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.activityExecTime"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "row form-group" }),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Lugar de Ejecución Actividad *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has(
                          "custom-document.activityExecPlace"
                        )
                          ? false
                          : null,
                        "data-cy": "activity-exec-place",
                        "data-vv-as": "lugar de ejecución",
                        name: "activityExecPlace",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.activityExecPlace,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "activityExecPlace", $$v)
                        },
                        expression: "formData.activityExecPlace"
                      }
                    }),
                    _vm.errors.has("custom-document.activityExecPlace")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.activityExecPlace"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label:
                        "Que Autoridades Participan (ingresar una autoridad por línea) *"
                    }
                  },
                  [
                    _c("b-form-textarea", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        max: "",
                        maxlength: "5000",
                        rows: _vm.formData.authorities.length + 1 || 2,
                        danger: _vm.errors.has("custom-document.authorities"),
                        "danger-text": _vm.errors.first(
                          "custom-document.authorities"
                        ),
                        "data-cy": "authorities",
                        "data-vv-as": "que autoridades participan",
                        name: "authorities"
                      },
                      on: {
                        input: function(value) {
                          _vm.authoritiesStr = value
                          _vm.formData.authorities = value
                            .split("\n")
                            .filter(function(authority) {
                              return authority.trim()
                            })
                        }
                      },
                      model: {
                        value: _vm.authoritiesStr,
                        callback: function($$v) {
                          _vm.authoritiesStr = $$v
                        },
                        expression: "authoritiesStr"
                      }
                    }),
                    _vm.errors.has("custom-document.authorities")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.authorities"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.formData.authorities.length
                  ? _c("div", [
                      _c("b", [_vm._v("Autoridades ingresadas: ")]),
                      _c(
                        "ul",
                        _vm._l(_vm.formData.authorities, function(authority) {
                          return _c("li", { key: authority }, [
                            _vm._v(" - " + _vm._s(authority) + " ")
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Tipos de Requerimiento *" } },
                  [
                    _vm.loadingRequirementTypes
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-center flex items-center gap-2 justify-content-center"
                          },
                          [
                            _vm._v(" Cargando tipos de requerimiento... "),
                            _c("b-spinner", { attrs: { label: "Cargando..." } })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("b-form-checkbox-group", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "mt-3",
                      attrs: {
                        id: "requirementTypes",
                        name: "requirementTypes",
                        "data-cy": "requirement-types",
                        "data-vv-as": "tipo de requerimiento",
                        options: _vm.requirementTypeOptions,
                        switches: ""
                      },
                      model: {
                        value: _vm.formData.requirementTypes,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "requirementTypes", $$v)
                        },
                        expression: "formData.requirementTypes"
                      }
                    }),
                    _vm.otherTextFieldEnabled
                      ? _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            state: _vm.errors.has(
                              "custom-document.otherRequirement"
                            )
                              ? false
                              : null,
                            "data-cy": "other-requirement",
                            "data-vv-as": "otro",
                            name: "otherRequirement",
                            type: "text",
                            placeholder: "Ingrese otro tipo de requerimiento"
                          },
                          model: {
                            value: _vm.formData.otherRequirement,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "otherRequirement", $$v)
                            },
                            expression: "formData.otherRequirement"
                          }
                        })
                      : _vm._e(),
                    _vm.errors.has("custom-document.otherRequirement")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.otherRequirement"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.errors.has("custom-document.requirementTypes")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.requirementTypes"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Especificaciones Técnicas (EETT) *" } },
                  [
                    _c("editor-text", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "-mb-4",
                      attrs: {
                        danger: _vm.errors.has(
                          "custom-document.technicalSpecs"
                        ),
                        "danger-text": _vm.errors.first(
                          "custom-document.technicalSpecs"
                        ),
                        "data-cy": "technical-specs",
                        "data-vv-as": "especificaciones técnicas",
                        name: "technicalSpecs",
                        "with-counter": ""
                      },
                      model: {
                        value: _vm.formData.technicalSpecs,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "technicalSpecs", $$v)
                        },
                        expression: "formData.technicalSpecs"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Presupuesto Disponible *" } },
                  [
                    _c("InputCurrency", {
                      ref: "availableBudget",
                      attrs: {
                        label: "",
                        options: {
                          locale: "es-CL",
                          currency: "CLP",
                          hideGroupingSeparatorOnFocus: false,
                          currencyDisplay: "hidden",
                          precision: {
                            min: 0,
                            max: 2
                          }
                        },
                        id: "availableBudget",
                        name: "availableBudget",
                        "data-cy": "available-budget",
                        disabled: _vm.formData.budgetNotRequired,
                        state: _vm.errors.has("custom-document.availableBudget")
                          ? false
                          : null,
                        danger: _vm.errors.has(
                          "custom-document.availableBudget"
                        ),
                        "danger-text": _vm.errors.first(
                          "custom-document.availableBudget"
                        )
                      },
                      model: {
                        value: _vm.formData.availableBudget,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "availableBudget", $$v)
                        },
                        expression: "formData.availableBudget"
                      }
                    }),
                    _c(
                      "b-form-checkbox",
                      {
                        staticClass: "m-0",
                        attrs: { "data-cy": "budget-not-required", switch: "" },
                        on: {
                          change: function($event) {
                            return _vm.resetBudget()
                          }
                        },
                        model: {
                          value: _vm.formData.budgetNotRequired,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "budgetNotRequired", $$v)
                          },
                          expression: "formData.budgetNotRequired"
                        }
                      },
                      [_vm._v(" Según cotización ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._m(0),
          _c(
            "div",
            { staticClass: "row gap-y-2 mt-2" },
            [
              _c("upload-file", {
                attrs: {
                  "data-cy": "annex-file",
                  permission: "*",
                  accept: "application/pdf, .doc, .docx, .xlsv, .ppt",
                  text: "Adjuntar anexo desde equipo",
                  "upload-to": "ed",
                  "container-class": "col-12 col-md-6 col-lg-6 col-xl-3",
                  "button-class": "btn-block flex-1"
                },
                on: { input: _vm.addAnnexFile },
                model: {
                  value: _vm.annexFile,
                  callback: function($$v) {
                    _vm.annexFile = $$v
                  },
                  expression: "annexFile"
                }
              }),
              _c(
                "div",
                { staticClass: "col-12 col-md-6 col-lg-6 col-xl-3" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED060",
                          expression: "'ED060'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "add-annex-file-repository",
                          expression: "'add-annex-file-repository'"
                        }
                      ],
                      staticClass: "btn-block",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "annex-file-repository"
                      }
                    },
                    [_vm._v(" Adjuntar anexo desde repositorio ")]
                  )
                ],
                1
              ),
              _vm._l(_vm.annexFiles, function(file) {
                return _c(
                  "div",
                  {
                    key: file.id,
                    staticClass: "col-12 col-sm-6 col-md-4 col-xl-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "description",
                            size: "25px",
                            color: "primary"
                          }
                        }),
                        _c(
                          "b",
                          { staticClass: "text-truncate w-100 text-center" },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        _c("vs-button", {
                          attrs: {
                            "data-cy": "remove-annex-file",
                            color: "danger",
                            type: "flat",
                            icon: "clear"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeAnnexFile(file.id)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              })
            ],
            2
          ),
          !!_vm.error.message
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-right"
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "cancel",
                color: "primary",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "save",
                color: "success",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Crear "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-primary"
              })
            ]
          )
        ],
        1
      ),
      _c("repository-selector", {
        attrs: {
          "modal-id": "add-annex-file-repository",
          "add-file": _vm.addAnnexFile,
          files: _vm.annexFiles,
          "remove-file": _vm.removeAnnexFile,
          "max-files": 1
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-5" }, [
      _c("span", { staticClass: "italic" }, [
        _c("b", [_vm._v("( * )")]),
        _vm._v(
          " En caso de detallar mayores antecedentes, remitir anexo con Especificaciones Técnicas "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }